import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';

/**
 * Tela `/finance/disputes` — placeholder. Não existe coleção de
 * chargebacks/disputas; a tela mostra vazio explícito em vez de inventar dado.
 *
 * Origem: sem issue — commit 973be8d9c, 2026-05-05 (Sprint 5 PR H, painel
 * financeiro).
 *
 * Usado por: rota `finance/disputes` (`routes/router.tsx`), menu Cobrança
 * (`AdminLayout`). Spec: `docs/screens/finance-disputes.md` (placeholder).
 *
 * Arquitetura: o webhook de disputa JÁ é tratado no servidor desde
 * 2026-09-25 (#740, `apps/functions/src/billing/webhooks/handleChargeDispute.ts`):
 * grava `disputed_amount` no `payment` e avisa os admins por `notifyAdmins`,
 * mas não cria coleção própria. Hoje a disputa só aparece no pagamento
 * (`/finance/transactions`).
 *
 * Histórico:
 *  - 2026-10-10 13:39 +0200 — (#926) o comentário dizia que o webhook
 *    `charge.dispute.created` ainda não era tratado; é, desde #740.
 */
export function DisputesPage(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <ContentLayout
      header={
        <Header variant="h1" description={t('admin.finance.disputes.subtitle')}>
          {t('admin.finance.disputes.title')}
        </Header>
      }
    >
      <Container>
        <Box textAlign="center" padding="xl">
          <SpaceBetween size="xs">
            <Box variant="strong">{t('admin.finance.disputes.emptyTitle')}</Box>
            <Box color="text-body-secondary">{t('admin.finance.disputes.emptyDescription')}</Box>
          </SpaceBetween>
        </Box>
      </Container>
    </ContentLayout>
  );
}
